<template>
  <div>
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
    <v-container fluid>
      <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
        <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
        <v-btn dark text @click="snackbar = false">Close</v-btn>
      </v-snackbar>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>

      <v-card class="box">
        <v-toolbar flat dense class="toolbar">
          <v-toolbar-title>Canteen Daily Receipts Report</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-row justify="center" dense>
          <v-col cols="12" sm="3">
            <p><b>From Date</b></p>
            <v-text-field outlined dense type="date" v-model="fromdate"></v-text-field>
          </v-col>
          <v-col cols="12" sm="3">
            <p><b>To Date</b></p>
            <v-text-field outlined dense type="date" v-model="todate"></v-text-field>
          </v-col>
          <v-col cols="12" sm="2" class="pt-4" v-if="fromdate && todate">
            <br />
            <v-btn color="brand onBrand--text" @click="getCanteenReceiptsReport()">Fetch</v-btn>
          </v-col>
        </v-row>
      </v-card>

      <v-card class="box" v-if="canteen_receipts_data!=''">
        <v-data-table :headers="headers" :items="canteen_receipts_data">
          <template v-slot:top>
            <v-toolbar flat class="toolbar">
              <v-toolbar-title>Canteen Receipts List</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-spacer></v-spacer>
            </v-toolbar>
          </template>
          <template v-slot:[`item.receipt_no`]="{ item }">
            <v-tooltip top color="warning">
              <template v-slot:activator="{ on, attrs }">
                <v-btn class="mt-1 mb-1" outlined rounded small color="warning" v-bind="attrs" v-on="on"
                  @click="print(item.receipt_no,item.ay,item.registration_number)">
                  <v-icon color="warning">mdi-printer</v-icon>{{ item.receipt_no }}</v-btn>
              </template>
              <span> Print Fee Receipt!!! </span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-card>
    </v-container>
  </div> <!-- /. root div -->
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
  components: {
    Breadcrumbs,
  },
    data: () => ({
      loader:false,
      snackbar_msg: "",
      color: "",
      // extraBreadcrumbItems: [


      // ],
      // breadcrumbClass: "breadcrumb-style1",
      snackbar: false,
      overlay: false,
      fromdate: new Date().toISOString().slice(0, 10),
      todate: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 1).toISOString().substr(0, 10),
      headers:[
        { text: "SR No", value: "count" },
        { text: "Receipt No", value: "receipt_no" },
        { text: "Name", value: "name" },
        { text: "Amount", value: "amount" },
        { text: "Receipt Date", value: "receipt_date" },
        { text: "Academicyear", value: "academicyear" },
        { text: "Installment", value: "learnercanteenfeesinstallment" },
        { text: "Remark", value: "remark" }
      ],
      canteen_receipts_data:[]
  }),
   methods: {
      print(receipt_no, ay) {
        this.receipt_no = receipt_no;
        this.$session.set("receipt_no", JSON.stringify(receipt_no));
        this.$session.set("ay", JSON.stringify(ay));
        let routeData = this.$router.resolve({ name: "canteen-receipt" });
        window.open(routeData.href, "_blank");
    },
    getCanteenReceiptsReport(){
         const data = {
        fromdate: this.fromdate,
        todate: this.todate,
      };
      this.overlay = true;
      axios
        .post("/Canteen/getCanteenReceiptsReport",data)
        .then((res) => {
          this.overlay = false;
          if (res.data.flag == "YES") {
             this.canteen_receipts_data = res.data.canteen_receipt_details;
          }  else if (res.data.flag == "No") {
            this.showSnackbar("red", res.data.snackbar);
          } else {
            this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          window.console.log(error);
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
  },
   mounted() {
   // this.onLoad();
  },
  watch: {},
};
</script>
<style scoped>
</style>